import { render, staticRenderFns } from "./choicePackage.vue?vue&type=template&id=b782e316&scoped=true&"
import script from "./choicePackage.vue?vue&type=script&lang=js&"
export * from "./choicePackage.vue?vue&type=script&lang=js&"
import style0 from "./choicePackage.vue?vue&type=style&index=0&id=b782e316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b782e316",
  null
  
)

export default component.exports